import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button, Header, Modal, Accumulator } from '@adc/ui-core'
import DataTableUtils from '../utils'

const EditDataColumnsMenuItem = {
  key: 'edit-data-columns',
  value: 'edit-data-columns',
  text: 'Edit Data Columns',
}

class EditDataColumnsModal extends Component {
  static propTypes = {
    modalOpen: PropTypes.bool.isRequired,
    closeModal: PropTypes.func.isRequired,
    saveConfig: PropTypes.func.isRequired,
    allColumns: PropTypes.array.isRequired,
    selectedColumns: PropTypes.array.isRequired,
  }

  static defaultProps = {
    modalOpen: false,
  }

  constructor(props) {
    super(props)

    const dataColumns = DataTableUtils.getDataColumns(props.allColumns)
    const allOptions = dataColumns.map(column => {
      return { key: column.field, value: column.field, text: column.title }
    })

    const selectedOptions = this.getSelectedOptions(props.selectedColumns)

    this.state = {
      selectedOptions,
      allOptions,
    }
  }

  // eslint-disable-next-line
  UNSAFE_componentWillReceiveProps(nextProps) {
    const selectedOptions = this.getSelectedOptions(nextProps.selectedColumns)
    this.setSelectedOptions(selectedOptions)
  }

  getSelectedOptions = options => {
    return options.reduce((init, column) => {
      if (column.colProps.isVisible) init.push(column.field)
      return init
    }, [])
  }

  setSelectedOptions = options => {
    // => options is list of value strings
    this.setState({ selectedOptions: options })
  }

  updateConfigurableColumns = values => {
    this.setSelectedOptions(values)
  }

  saveConfigurableColumns = () => {
    this.props.saveConfig(this.state.selectedOptions)
  }

  render() {
    return (
      <Modal
        closeOnDimmerClick={false}
        elmId='modal_edit_column_config'
        size='small'
        open={this.props.modalOpen}
        onClose={this.props.closeModal}
        closeIcon={false}
        mobileTitleSkin='light'
      >
        <Header
          as='h2'
          content={EditDataColumnsMenuItem.text}
          data-elm-id='header_edit_column_config'
        />
        <Modal.Content>
          <p data-elm-id='content_edit_column_config'>
            Select columns to show in the table.
          </p>
          <Accumulator
            elmId='accumulator'
            initialSelectedValues={this.state.selectedOptions}
            allOptions={this.state.allOptions}
            onUpdate={this.updateConfigurableColumns}
            selectedListHeader='Selected Columns'
            unselectedListHeader='Available Columns'
            helpText='Tip: you can drag-and-drop to add or re-order columns.'
          />
        </Modal.Content>
        <Modal.Actions>
          <Button
            size='small'
            elmId='button_cancel_edit_column_config'
            onClick={this.props.closeModal}
          >
            Cancel
          </Button>
          <Button
            role='primary'
            size='small'
            elmId='button_save_edit_column_config'
            disabled={this.state.selectedOptions.length === 0}
            onClick={this.saveConfigurableColumns}
          >
            Save
          </Button>
        </Modal.Actions>
      </Modal>
    )
  }
}

export default EditDataColumnsModal
export { EditDataColumnsMenuItem }
